import { Switch } from 'radix-ui';
import { type ReactNode, useId } from 'react';
import { cn } from '../../../../lib/cn';

/**
 * Przełącznik z etykietą i opisem (Uprawnienia specjalne). Radix Switch (role="switch", Spacja).
 * Komponent lokalny modułu: w `ui/` nie ma jeszcze Switch (propozycja do przeniesienia).
 */
export function SwitchRow({
  checked,
  onCheckedChange,
  label,
  description,
  note,
  disabled = false,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: ReactNode;
  description?: ReactNode;
  /** dodatkowa notka pod opisem (np. sejf) */
  note?: ReactNode;
  disabled?: boolean;
}) {
  const id = useId();
  return (
    <div className="flex items-start gap-4 border-b border-line py-3">
      <div className="min-w-0 flex-1">
        <label htmlFor={id} className="block text-body-s font-medium text-fg">
          {label}
        </label>
        {description && (
          <p id={`${id}-d`} className="mt-0.5 text-caption text-fg-muted">
            {description}
          </p>
        )}
        {note && <p className="mt-1 text-caption text-fg-secondary">{note}</p>}
      </div>
      <Switch.Root
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        aria-describedby={description ? `${id}-d` : undefined}
        className={cn(
          'relative mt-0.5 inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full bg-line-strong transition-colors',
          'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
          'data-[state=checked]:bg-accent disabled:cursor-not-allowed disabled:opacity-50',
        )}
      >
        <Switch.Thumb
          className={cn(
            'block size-4 translate-x-0.5 rounded-full bg-canvas shadow-xs transition-transform',
            'data-[state=checked]:translate-x-[18px]',
          )}
        />
      </Switch.Root>
    </div>
  );
}
